// extracted by mini-css-extract-plugin
export default {"input":"Search_input__jSxcQ"};